import { useRef, useCallback } from 'react';
import { Input } from '@/components/ui/input';

interface DateCellEditorProps {
  value: unknown;
  ariaLabel?: string;
  onChange: (value: string | null) => void;
  onCommit: () => void;
  onCancel: () => void;
}

export function DateCellEditor({ value, ariaLabel, onChange, onCommit, onCancel }: DateCellEditorProps) {
  const committedRef = useRef(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const stringValue = value ? String(value) : '';

  const commit = useCallback((dateStr: string) => {
    if (committedRef.current) return;
    committedRef.current = true;
    onChange(dateStr || null);
    onCommit();
  }, [onChange, onCommit]);

  const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      commit(inputRef.current?.value ?? '');
    } else if (e.key === 'Escape') {
      e.stopPropagation();
      onCancel();
    }
  }, [commit, onCancel]);

  const handleBlur = useCallback(() => {
    if (!committedRef.current) {
      commit(inputRef.current?.value ?? '');
    }
  }, [commit]);

  return (
    <Input
      ref={inputRef}
      type="date"
      defaultValue={stringValue}
      aria-label={ariaLabel}
      autoFocus
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      className="cell-editing-input text-xs font-mono h-7 w-full px-2"
    />
  );
}
